module.exports = __webpack_public_path__ + "static/media/partner-cream.0d8b303d.svg";